export const isF1Device = (): boolean => {
  if (typeof window === 'undefined' || !('localStorage' in window)) {
    return false;
  }

  try {
    const os = window.localStorage.getItem('device_os');
    const type = window.localStorage.getItem('device_type');
    return os === 'android' && type === 'f1-terminal';
  } catch {
    // in case accessing localStorage throws (privacy mode, disabled, etc.)
    return false;
  }
};
